import React from 'react';
import { Dialog, DialogContent } from './styles';

type FullScreenLoaderModalProps = {
  open: boolean;
  children: React.ReactNode;
};

export default function FullScreenLoaderModal({
  open,
  children,
}: FullScreenLoaderModalProps) {
  return (
    <Dialog open={open} aria-labelledby="draggable-dialog-title">
      <DialogContent>{children}</DialogContent>
    </Dialog>
  );
}
